module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "one-line": ""
    }
  }, [_c('v-list-group', {
    attrs: {
      "value": "true"
    }
  }, [_c('v-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Link your personal data vault")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1), _vm._v(" "), _vm._l((_vm.limitedProviderList), function(provider) {
    return _c('v-list-tile', {
      key: provider.Code,
      attrs: {
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.linkProvider(provider.Code)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      class: [provider.Code]
    }, [_vm._v("\n                    fa-" + _vm._s(provider.Code) + "\n                ")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(provider.Name)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_c('div', {
      class: _vm.statusClass(provider.Code)
    }, [_vm._v(_vm._s(_vm.status(provider.Code)))])])], 1)], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42aa47c5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/me/DatastoreConnections.vue
// module id = 335
// module chunks = 2